export default {
  home: {
    navTitle: {
      de: 'Startseite',
      en: 'Home',
      ru: 'Главная'
    },
    headerTitle: {
      de: 'Digital Humanities of the North',
      en: 'Digital Humanities of the North',
      ru: 'Цифровые гуманитарные науки Севера'
    },
    slug: 'startseite',
    path: '/'
  },
  info: {
    navTitle: {
      de: 'Info',
      en: 'Info',
      ru: 'Справка'
    },
    slug: null
  },
  kss: {
    navTitle: {
      de: 'Kulturstiftung Sibirien',
      en: 'Kulturstiftung Sibirien',
      ru: 'Фонд культуры народов Сибири'
    },
    headerTitle: {
      de: 'Kulturstiftung Sibirien',
      en: 'Kulturstiftung Sibirien',
      ru: 'Фонд культуры народов Сибири'
    },
    slug: 'kulturstiftung-sibirien',
    path: '/themen/kulturstiftung-sibirien'
  },
  partner: {
    navTitle: {
      de: 'Partner',
      en: 'Partners',
      ru: 'Партнёры'
    },
    headerTitle: {
      de: 'Partner',
      en: 'Partners',
      ru: 'Партнёры'
    },
    slug: 'partner',
    path: '/themen/kulturstiftung-sibirien'
  },
  datenschutzerklaerung: {
    navTitle: {
      de: 'Datenschutzerklärung',
      en: 'Privacy Policy',
      ru: 'Политика конфиденциальности'
    },
    headerTitle: {
      de: 'Datenschutzerklärung',
      en: 'Privacy Policy',
      ru: 'Политика конфиденциальности'
    }
  },
  impressum: {
    navTitle: {
      de: 'Impressum',
      en: 'Legal',
      ru: 'Контакты'
    },
    headerTitle: {
      de: 'Impressum',
      en: 'Legal',
      ru: 'Контакты'
    }
  },
  subjects: {
    navTitle: {
      de: 'Themen',
      en: 'Themes',
      ru: 'Темы'
    },
    headerTitle: {
      de: 'Themen',
      en: 'Themes',
      ru: 'Темы'
    },
    slug: 'themen',
    path: 'themen'
  },
  ethnografies: {
    navTitle: {
      de: 'Ethnografien',
      en: 'Ethnographies',
      ru: 'Этнографии'
    },
    headerTitle: {
      de: 'Ethnografien',
      en: 'Ethnographies',
      ru: 'Этнографии'
    },
    slug: 'ethnografien',
    path: ''
  },
  ethnie: {
    navTitle: {
      de: 'Ethnie',
      en: 'Ethnic Group',
      ru: 'Народ'
    },
    headerTitle: {
      de: 'Ethnie',
      en: 'Ethnic Group',
      ru: 'Народ'
    },
    slug: 'ethnie',
    path: ''
  },
  allEthnografies: {
    navTitle: {
      de: 'Übersicht Ethnografien',
      en: 'Ethnographies Overwiew',
      ru: 'Обзор народов'
    },
    headerTitle: {
      de: 'Übersicht Ethnografien',
      en: 'Ethnographies Overview',
      ru: 'Обзор народов'
    },
    slug: 'alle-ethnien',
    path: 'ethnien'
  },
  allSubjects: {
    navTitle: {
      de: 'Themen',
      en: 'Themes',
      ru: 'Темы'
    },
    headerTitle: {
      de: 'Themenübersicht',
      en: 'Themes',
      ru: 'Темы'
    },
    slug: 'alle-themen',
    path: 'themen'
  },
  allVideos: {
    navTitle: {
      de: 'Videos',
      en: 'Videos',
      ru: 'Видео'
    },
    headerTitle: {
      de: 'Videos',
      en: 'Videos',
      ru: 'Видео'
    },
    slug: 'alle-videos',
    path: 'videos'
  },
  videos: {
    navTitle: {
      de: 'Videos',
      en: 'Videos',
      ru: 'Видео'
    },
    headerTitle: {
      de: 'Videos',
      en: 'Videos',
      ru: 'Видео'
    },
    slug: 'videos',
    path: '/medien/videos'
  },
  ethnographica: {
    navTitle: {
      de: 'Ethnographica',
      en: 'Ethnographica',
      ru: 'Этнографические предметы'
    },
    headerTitle: {
      de: 'Ethnographica',
      en: 'Ethnographica',
      ru: 'Этнографические предметы'
    },
    slug: 'ethnographica',
    path: '/medien/ethnographica'
  },
  fotos: {
    navTitle: {
      de: 'Fotos',
      en: 'Fotos',
      ru: 'Фото'
    },
    headerTitle: {
      de: 'Fotos',
      en: 'Fotos',
      ru: 'Фото'
    },
    slug: 'ethnographica',
    path: '/medien/ethnographica'
  },
  buecher: {
    navTitle: {
      de: 'Bücher',
      en: 'Books',
      ru: 'Книги'
    },
    headerTitle: {
      de: 'Bücher',
      en: 'Books',
      ru: 'Книги'
    },
    slug: 'buecher',
    path: '/bibliothek/buecher'
  },
  autographen: {
    navTitle: {
      de: 'Autographen',
      en: 'Autographs',
      ru: 'Автограф'
    },
    headerTitle: {
      de: 'Autographen',
      en: 'Autographs',
      ru: 'Автограф'
    },
    slug: 'autographne',
    path: '/bibliothek/autographen'
  },
  digitaleBibliothek: {
    navTitle: {
      de: 'Digitale Bibliothek',
      en: 'Digital Library',
      ru: 'Электронная библиотека'
    },
    headerTitle: {
      de: 'Digitale Bibliothek',
      en: 'Digital Library',
      ru: 'Электронная библиотека'
    },
    slug: 'buecher',
    path: '/bibliothek/buecher'
  },
  weitereDigitalisate: {
    navTitle: {
      de: 'Weitere Digitalisate',
      en: 'Digital Materials',
      ru: 'Цифровые материалы'
    },
    headerTitle: {
      de: 'Weitere Digitalisate',
      en: 'Digital Materials',
      ru: 'Цифровые материалы'
    },
    slug: 'buecher',
    path: '/bibliothek/buecher'
  },
  dossiers: {
    navTitle: {
      de: 'Dossiers',
      en: 'Dossiers',
      ru: 'Досье'
    },
    headerTitle: {
      de: 'Dossiers',
      en: 'Dossiers',
      ru: 'Досье'
    },
    slug: 'buecher',
    path: '/bibliothek/buecher'
  },
  // digitaleBibliothek: {
  //   navTitle: {
  //     de: 'Digitale Bibliothek',
  //     en: 'Digital Library',
  //     ru: 'Digital Library'
  //   },
  //   headerTitle: {
  //     de: 'Digitale Bibliothek',
  //     en: 'Digital Library',
  //     ru: 'Digital Library'
  //   },
  //   slug: 'buecher',
  //   path: '/bibliothek/buecher'
  // },
  video: {
    navTitle: {
      de: 'Video',
      en: 'Video',
      ru: 'Видео'
    },
    headerTitle: {
      de: 'Video',
      en: 'Video',
      ru: 'Видео'
    },
    slug: 'video',
    path: 'video'
  },
  objekt: {
    navTitle: {
      de: 'Objekt',
      en: 'Object',
      ru: 'Предмет'
    },
    headerTitle: {
      de: 'Objekt',
      en: 'Object',
      ru: 'Предмет'
    },
    slug: 'objekt',
    path: 'objekt'
  },
  sammlungen: {
    navTitle: {
      de: 'Sammlungen',
      en: 'Collections',
      ru: 'Коллекции'
    },
    headerTitle: {
      // de: 'Sammlungen der Kulturstiftung Sibirien',
      // en: 'Collections of the Kulturstiftung Sibirien',
      // ru: 'Коллекции Фонда культуры народов Сибири'
      de: 'Sammlungen',
      en: 'Collections',
      ru: 'Коллекции'
    },
    slug: 'sammlungen',
    path: 'sammlungen'
  },
  verlag: {
    navTitle: {
      de: 'Verlag',
      en: 'Publishing House',
      ru: 'Издательство'
    },
    headerTitle: {
      // de: 'Verlag der Kulturstiftung Sibirien',
      // en: 'Publishing House of Kulturstiftung Sibirien',
      // ru: 'Издательство Фонда культуры народов Сибири'
      de: 'Verlag',
      en: 'Publishing House',
      ru: 'Издательство'
    },
    slug: 'dl',
    path: 'dl'
  },
  langSwitch: {
    de: 'Language',
    en: 'Language',
    ru: 'Язык'
  },
  dossier: {
    navTitle: {
      de: 'Dossier',
      en: 'Dossier',
      ru: 'досье'
    },
    slug: 'lang-switch',
    headerTitle: {
      de: 'Dossier',
      en: 'Dossier',
      ru: 'досье'
    },
    path: 'dossier'
  },
  publication: {
    navTitle: {
      de: 'Publikation',
      en: 'Publication',
      ru: 'Публикация'
    },
    headerTitle: {
      de: 'Publikation',
      en: 'Publication',
      ru: 'Публикация'
    },
    path: 'publikation'
  }
}
